export { EloPrzelewy24Icon } from './przelewy24-icon'
